export default __webpack_public_path__ + "static/media/image2.09741821.jpg";